export * from './src/portfolio-projects-v1-project-projects.meta.js';
